import { FelaCSS, colors, spacing } from '@bridebook/ui';
import { IThemeProperties } from '@bridebook/web/lib/wedding-website/utils';

interface IStyles {
  container: FelaCSS;
  header: FelaCSS;
  title: FelaCSS;
  backButtonIcon: FelaCSS;
  progressBarContainer: FelaCSS;
  progressMarker: FelaCSS;
}

const componentStyles: (themeProperties: IThemeProperties) => IStyles = (themeProperties) => ({
  container: {
    position: 'sticky',
    top: 0,
    zIndex: 80,
    backgroundColor: themeProperties.paletteColors.backgroundAlt,
    paddingVertical: spacing[4],
    paddingHorizontal: spacing[6],
    borderBottom: `1px solid ${colors.space15}`,
    supportsSafeAreaInset: {
      paddingTop: `calc(env(safe-area-inset-top) + ${spacing[4]})`,
    },
    minWidthMobileLg: {
      backgroundColor: 'transparent',
      paddingVertical: spacing[6],
      paddingHorizontal: spacing[10],
      gap: spacing[2],
      position: 'static',
    },
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  backButtonIcon: {
    transform: 'rotate(90deg)',
  },
  title: {
    margin: 0,
    textAlign: 'center',
    fontPlayfair: 24,
    color: colors.space,
  },
  progressBarContainer: {
    paddingTop: spacing[6],
    paddingBottom: spacing[1],
  },
  progressMarker: {
    left: 'calc(100% - 9px)',
  },
});

export default componentStyles;
